import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filter'; // global filters
import vuetify from './plugins/vuetify';
import { dbio } from './plugins/axios';
import { msg } from './plugins/common';
import './styles/transition.scss';

// --- 基礎環境判斷 ---
const env = process.env.VUE_APP_MODE;
const modeMap = {
  prod: { label: 'Production', color: '#7b7b7b' },
  staging: { label: 'Staging', color: '#ff9800' },
  dev: { label: 'Development', color: '#26824E' }
};
const defaultMode = { label: 'Unknown', color: '#000000' };
// --- 打包時間 ---
const buildTime = process.env.BUILD_TIME 

// --- 根據模式決定背景顏色 ---
const mode = modeMap[env] || defaultMode;
console.log(
  `%c clientRental Mode: ${mode.label} %c Build: ${buildTime} `,
  `background: ${mode.color}; color: #ffffff; padding: 2px 4px; border-radius: 3px 0 0 3px;`,
  'background: #26824E; color: #ffffff; padding: 2px 4px; border-radius: 0 3px 3px 0;'
);
Vue.config.productionTip = false

Vue.mixin({
  methods: {
    dbio,
    msg
  }
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
